<template>
  <div :data-testid="props.dataTestid" v-for="n in props.count" :key="n" v-bind="$attrs" :class="$attrs.class || twMerge('flex gap-3 mb-4', props.appendClass)">
    <div role="status" class="flex items-center justify-center w-28 h-28 bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700">
      <div class="flex items-center justify-center h-28 w-28 bg-gray-300 rounded dark:bg-gray-700">
        <svg class="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
          <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
        </svg>
      </div>
    </div>
    <div class="w-full flex flex-col justify-between"> 
      <div class="flex justify-between">
        <div class="animate-pulse h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-1/2 max-w-[440px] mt-2"></div>
        <TsIcon name="ant-design:delete-filled" size="22" class="animate-pulse text-gray-200 dark:text-gray-600 size-5" />
      </div>
      <div class="flex justify-between items-end">
        <div class="animate-pulse bg-gray-200 rounded-sm dark:bg-gray-700 w-20 h-8 mt-4 flex justify-between px-2 items-center">
          <div class="animate-pulse h-5 w-5 bg-gray-300 rounded-full dark:bg-gray-600"></div>
          <div class="animate-pulse h-5 w-5 bg-gray-300 rounded-full dark:bg-gray-600"></div>
        </div>
      <div class="flex flex-col items-end gap-y-3">
        <div class="animate-pulse bg-gray-200 rounded-md dark:bg-gray-700 w-16 h-2"></div>
        <div class="animate-pulse bg-gray-200 rounded-md dark:bg-gray-700 w-32 h-2"></div>
      </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

// Dynamic attribute binding
defineOptions({
  inheritAttrs: false,
});

type Props = {
  count?: number;
  appendClass?: string;
  dataTestid?:string;
}
const props = withDefaults(defineProps<Props>(), {
  count: 1,
  dataTestid:'organisms-trollycardtransition'
});
</script>
